import React, { Fragment, useEffect, useState } from "react";
import faq1 from "../assets/faq1.png";
import { FAQCard } from "@/components";
import { NavLink } from "react-router-dom";

const FAQ: React.FC = () => {
  const [openId, setOpenId] = useState<number | null>(null);

  const handleToggle = (id: number) => {
    setOpenId(openId === id ? null : id);
  };

  const [isMobile, setIsMobile] = useState<boolean>(false);

  const checkIsMobile = () => {
    setIsMobile(window.innerWidth <= 768);
  };

  useEffect(() => {
    checkIsMobile();
    window.addEventListener("resize", checkIsMobile);
    return () => {
      window.removeEventListener("resize", checkIsMobile);
    };
  }, []);

  return (
    <div className="faq max-[899px]:overflow-x-hidden">
      <div className="faq__1 gap-24 py-[3rem] px-[13rem] max-[1440px]:px-[5rem] max-[899px]:px-0 max-[899px]:flex-col">
        <div className="flex flex-col gap-32 max-[899px]:gap-4">
          <div className="faq__1__title">
            <span>FAQ</span>
            <br />
            Buy & Sell cryptocurrencies
          </div>
          <div className="flex flex-col gap-16">
            <div className="faq__1__text max-[899px]:w-[50%]">
              Leonext makes conversion safe and easy. After registration,
              convert <br /> your funds directly to your crypto wallet or bank
              account.
            </div>
            <NavLink to="/login">
              <div className="solutions__1__container__button ps-6 flex justify-start">
                Get Started{" "}
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="14"
                  height="14"
                  viewBox="0 0 14 14"
                  fill="none"
                >
                  <path
                    d="M0 4.46029H9.54638V14L14 9.54786V0H4.46583L0 4.46029Z"
                    fill="#35BCAB"
                  />
                </svg>
              </div>
            </NavLink>
          </div>
        </div>
        {isMobile ? (
          <img className="me-[-19rem] mt-[-15rem]" src={faq1} />
        ) : (
          <img src={faq1} />
        )}
        <div className="greenBarL"></div>
        {isMobile ? <Fragment /> : <div className="greenBarR"></div>}
      </div>

      <div className="faq__2 mb-[10rem] py-[3rem] px-[13rem] max-[1440px]:px-[5rem] max-[899px]:px-4">
        <FAQCard
          id={1}
          title="What is Leonext and what is its mission?"
          content="Leonext is a global fintech company specializing in crypto-to-fiat conversion for high-risk industries (B2B & HNI). Our mission is to make the transfer of value between cryptocurrency and traditional finance secure, transparent, and fully compliant. We operate under a VAAP license in Gibraltar and strictly follow AML/KYC standards."
          isOpen={openId === 1}
          onToggle={handleToggle}
        />
        <FAQCard
          id={2}
          title="What services does Leonext provide for businesses and how to start?"
          content="Crypto-to-fiat exchange, OTC desk and liquidity providing. To begin converting on LeoNext, visit www.leonext.exchange, and click on the Get Started or Sign Up button. Follow the registration process to create your account."
          isOpen={openId === 2}
          onToggle={handleToggle}
        />
        <FAQCard
          id={3}
          title="Is Leonext regulated and legal?"
          content="Yes. Leonext is licensed as a Virtual Asset Arrangement Provider (VAAP) by the Gibraltar Financial Services Commission (GFSC). We comply with EU and international standards,and strict AML/KYC practices, ensuring transparency, security, and customer protection."
          isOpen={openId === 3}
          onToggle={handleToggle}
        />
        <FAQCard
          id={4}
          title="In which countries and regions does Leonext operate?"
          content="Leonext provides services worldwide. The platform is available in any jurisdictions where fintech and crypto-fiat services are legally permitted. For restricted markets, we always conduct a compliance assessment before onboarding."
          isOpen={openId === 4}
          onToggle={handleToggle}
        />
        <FAQCard
          id={5}
          title="What kind of Digital Assents are available LEONEXT?"
          content="LEONEXT supports crypto like: Bitcoin (BTC), Ethereum (ETH), USDT (ERC20, TRC20), USDC(ERC20, TRC20)."
          isOpen={openId === 5}
          onToggle={handleToggle}
        />
        <FAQCard
          id={6}
          title="Which Fiat Currencies Does LEONEXT Support for Conversion?"
          content="LEONEXT supports the conversion of cryptocurrencies to various fiat currencies, including: EUR, USD, GBP."
          isOpen={openId === 6}
          onToggle={handleToggle}
        />
        <FAQCard
          id={7}
          title="What Fees Apply to Crypto to Fiat Conversion on LEONEXT?"
          content="LEONEXT charges competitive fees for crypto to fiat conversions. Detailed information on fees and costs every client can find in their contract."
          isOpen={openId === 7}
          onToggle={handleToggle}
        />
        <FAQCard
          id={8}
          title="Are There Limits on Crypto to Fiat Conversions?"
          content="Yes, there may be limits based on your account type and verification level. Refer to our Terms and Conditions page for detailed information."
          isOpen={openId === 8}
          onToggle={handleToggle}
        />
        <FAQCard
          id={9}
          title="Does Leonext work with high-risk industries?"
          content="Yes. We specialize in high-risk sectors, such as gaming, betting, trading, and fintech, where traditional banking solutions are often unavailable. Leonext provides secure, flexible, and reliable crypto-fiat exchange and payment services tailored to these industries."
          isOpen={openId === 9}
          onToggle={handleToggle}
        />
        <FAQCard
          id={10}
          title="How can I contact Leonext?"
          content="You can reach us via: The contact form on the Leonext website and Email: hello@leonext.exchange or support@leonext.exchange "
          isOpen={openId === 10}
          onToggle={handleToggle}
        />
        <FAQCard
          id={11}
          title="Are There Limits on Crypto to Fiat Conversions?"
          content="Yes, there may be limits based on your account type and verification level. Refer to our Terms and Conditions page for detailed information."
          isOpen={openId === 11}
          onToggle={handleToggle}
        />
        <FAQCard
          id={12}
          title="How Can I Reach LEONEXT Customer Support?"
          content="For assistance or inquiries, contact our customer support team through the Contact Us page or email support@leonext.exchange. We aim to provide timely and helpful responses."
          isOpen={openId === 12}
          onToggle={handleToggle}
        />
        <FAQCard
          id={13}
          title="Does LEONEXT Offer an API for Integration?"
          content="Yes, LEONEXT provides an API for seamless integration into third-party applications. Developers can find API documentation in the Developer Resources section."
          isOpen={openId === 13}
          onToggle={handleToggle}
        />
      </div>
    </div>
  );
};

export default FAQ;
